var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"chartElem"},[_c('div',{staticClass:"row align-center justify-center"},[_c('highcharts',{ref:"hc",staticClass:"chart",attrs:{"options":_vm.chartOptions,"updateArgs":_vm.updateArgs}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }